import { useState } from "react";
import Button from "../Button";
import Icon from "../icons/Icon";
import Sheet from "../Sheet";
import { readLog, clearLog, formatLog, formatZeit } from "../../diagnostics";
import "./ProtokollDialog.css";

/**
 * Verbindungs-Protokoll. Zeigt, was in der Minute vor einem Abbruch
 * passiert ist — der Abbruch selbst passiert immer dann, wenn niemand aufs
 * Display schaut. kontext: Zusatzzeilen fuer den kopierten Text.
 */
export function ProtokollDialog({ kontext, onClose }) {
  const [kopiert, setKopiert] = useState(false);
  // Erzwingt nach "Leeren" ein Neulesen des Ringpuffers
  const [, setStand] = useState(0);
  const eintraege = [...readLog()].reverse();

  const kopieren = async () => {
    const text = formatLog(kontext);
    try {
      await navigator.clipboard.writeText(text);
      setKopiert(true);
      setTimeout(() => setKopiert(false), 2500);
    } catch (err) {
      // iOS ohne Clipboard-Rechte: Text zum Markieren anbieten
      window.prompt("Zum Kopieren markieren:", text.slice(0, 4000));
    }
  };

  return (
    <Sheet
      titel="Verbindungs-Protokoll"
      mitX
      onClose={onClose}
      fuss={
        <div className="reihe">
          <Button variant="neben" onClick={kopieren}>
            <Icon name={kopiert ? "check" : "kopieren"} />
            {kopiert ? "Kopiert" : "Kopieren"}
          </Button>
          <Button
            variant="neben"
            className="falsch"
            onClick={() => {
              clearLog();
              setStand((n) => n + 1);
            }}
          >
            <Icon name="muell" />
            Leeren
          </Button>
        </div>
      }
    >
      <p className="sheet-hinweis">
        Läuft im Hintergrund mit, überlebt Neuladen. Nach einem Abbruch hier reinschauen oder kopieren und an Robin
        schicken.
      </p>
      {eintraege.length === 0 ? (
        <p className="protokoll-leer">Noch nichts passiert.</p>
      ) : (
        <ol className="diag-list">
          {eintraege.map((e, i) => (
            <li key={`${e.t}_${i}`} className={`diag-entry diag-${e.typ}`}>
              <time>{formatZeit(e.t)}</time>
              <em>{e.typ}</em>
              <span>
                {e.text}
                {e.n > 1 && <span className="diag-count"> {e.n}×</span>}
                {e.d && <span className="diag-data">{Object.entries(e.d).map(([k, v]) => ` ${k}=${v}`).join("")}</span>}
              </span>
            </li>
          ))}
        </ol>
      )}
    </Sheet>
  );
}

export default ProtokollDialog;
